/* eslint-disable no-unused-vars */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { AppBar, IconButton, Toolbar, colors } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';

import logo from '../assets/img/Alleva-Primary-White-Orang.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    background: theme.palette.slate.main,
    color: '#ffffff',
  },
  flexGrow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  logoLink: {
    fontSize: 0,
  },
  logoDiv: {
    visibility: 'hidden',
    marginTop: '20px',
  },
  logoImage: {
    width: '120px',
    transform: 'translate(12px, -14px)',
  },
}));

function TopBar({ onOpenNavBarMobile, className, ...rest }) {
  const classes = useStyles();

  return (
    <AppBar {...rest} className={clsx(classes.root, className)}>
      <Toolbar>
        <IconButton
          className={classes.menuButton}
          sx={{ display: { sm: 'none', xs: 'block' } }}
          color="inherit"
          onClick={onOpenNavBarMobile}
          size="large"
        >
          <MenuIcon />
        </IconButton>
        <RouterLink className={classes.logoLink} to="/">
          <div className={classes.logoDiv}>{logo}</div>
          <img className={classes.logoImage} alt="Logo" src="/img/Alleva-Primary-White-Orang.svg" />
        </RouterLink>
        <div className={classes.flexGrow} />
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
};

export default TopBar;
